<script>
import {GiftCardsTerms} from "../controllers/gift-cards.terms";

export default {
    name: "gift-cards.terms",
    mixins: [GiftCardsTerms]
}
</script>

<template>
    <main>
        <section class="hero-wrap section py-4">
            <div class="hero-mask opacity-9 bg-light-1"></div>
            <div class="hero-bg" style="background-image:url('./images/bg/image-2.jpg');"></div>
            <div class="hero-content">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-md-10">
                            <h1 class="text-11 text-black mb-4">{{ terms.name }}</h1>
                            <a class="text-5 text-primary mb-4" :href="terms.url">
                                View {{ terms.name }} Gift Card
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section bg-white py-4">
            <article class="container" v-html="'&bull; ' + terms.description.replaceAll('\n', '<br/>&bull; ')"></article>
        </section>

    </main>

</template>
